import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import "primereact/resources/primereact.min.css";
import { Accordion, AccordionTab } from "primereact/accordion";
import "../styles/shop.css";
import { ThemeContext } from "../contexts/ThemeContext";

function FilterShop({ filters, setFilters, language,t }) {
  const { categories } = useSelector(state => state.categories);
  const [activeMainIndex, setActiveMainIndex] = useState([0]);
  const [expandedCategories, setExpandedCategories] = useState({});
  const { theme, toggleTheme } = useContext(ThemeContext);
  
  //   const [filters, setFilters] = useState({});

  //   ===================== for collapse ===================================
  const handleMainAccordionChange = e => {
    setActiveMainIndex(e.index);
  };
  const toggleCategory = categoryId => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };

  //   ===================== filter by category ===================================
  //   const handleCategoryFilterChange = (categoryId, isChecked, e) => {
  //     e.stopPropagation();
  //     const category = categories?.find(c => c.id == categoryId);
  //     if (!category) return;
  //     setFilters(prev => {
  //       const newFilters = { ...prev };
  //       if (isChecked) {
  //         newFilters[categoryId] = [categoryId, ...(category.children?.map(child => child.id) || [])];
  //       } else {
  //         delete newFilters[categoryId];
  //       }
  //       return newFilters;
  //     });
  //   };

  //   ===================== filter by sub category ===================================
  const handleSubcategoryFilterChange = (categoryId, subcategoryId, isChecked) => {
    setFilters(prev => {
      const newFilters = { ...prev };
      const category = categories?.find(c => c.id == categoryId);

      if (isChecked) {
        newFilters[categoryId] = [...(newFilters[categoryId] || []), subcategoryId];
        if (category?.children?.every(child => newFilters[categoryId]?.includes(child.id))) {
          newFilters[categoryId] = [...newFilters[categoryId], categoryId];
        }
      } else {
        newFilters[categoryId] = (newFilters[categoryId] || []).filter(id => id !== subcategoryId && id !== categoryId);
        if (newFilters[categoryId].length === 0) {
          delete newFilters[categoryId];
        }
      }

      return newFilters;
    });
  };

  //   ===================== Determine checkbox state ===================================
  const getCategoryCheckState = categoryId => {
    const categoryFilters = filters[categoryId] || [];
    const category = categories?.find(c => c.id == categoryId);
    if (!category || !category.children) return false;

    const allChildren = category.children || [];
    const selectedChildren = allChildren.filter(child => categoryFilters.includes(child.id)).length;

    // If category itself is selected or all children are selected
    if (categoryFilters.includes(categoryId) || (selectedChildren > 0 && selectedChildren === allChildren.length)) {
      return "checked";
    }
    // If some children are selected
    else if (selectedChildren > 0) {
      return "indeterminate";
    }
    // If nothing is selected
    return "unchecked";
  };

  //   ===================== toggle checkbox  ===================================
  const handleCategoryFilterChange = (categoryId, isChecked, e) => {
    e.stopPropagation();
    const category = categories?.find(c => c.id == categoryId);
    if (!category) return;

    setFilters(prev => {
      const newFilters = { ...prev };

      if (isChecked) {
        newFilters[categoryId] = [categoryId, ...(category.children?.map(child => child.id) || [])];
      } else {
        delete newFilters[categoryId];
      }

      return newFilters;
    });
  };

  //   ===================== clearing a single category filter  ===================================
  const handleClearCategory = categoryId => {
    setFilters(prev => {
      const newFilters = { ...prev };
      delete newFilters[categoryId];
      return newFilters;
    });
  };

  //   ===================== clearing a single subcategory filter  ===================================
  const handleClearSubcategory = (categoryId, itemId) => {
    setFilters(prev => {
      const newFilters = { ...prev };
      newFilters[categoryId] = newFilters[categoryId].filter(id => id !== itemId);

      // Remove parent category if it exists
      if (newFilters[categoryId]?.includes(categoryId)) {
        newFilters[categoryId] = newFilters[categoryId].filter(id => id !== categoryId);
      }

      // Clean up empty arrays
      if (!newFilters[categoryId]?.length) {
        delete newFilters[categoryId];
      }

      return newFilters;
    });
  };

  //   ===================== Handler for clearing all filters  ===================================
  const handleClearAll = () => {
    setFilters({});
  };

  //   ===================== rendering a category filter chip  ===================================
  const renderCategoryFilter = (categoryId, category) => (
    <div className='filter_clear' key={`filter-${categoryId}-self`}>
      <div className='clear_icon' onClick={() => handleClearCategory(categoryId)}>
        <img src='/assets/images/white/close.svg' alt='clear filter' />
      </div>
      <div className='clear_title'>All {language === 'ar' ? category.name_ar || "Category" : category.name_en || "فئة"}</div>
    </div>
  );

  //   ===================== rendering a subcategory filter chip  ===================================
  const renderSubcategoryFilter = (categoryId, itemId, category) => {
    const subCategory = category?.children?.find(sc => sc.id == itemId);
    return (
      <div className='filter_clear' key={`filter-${categoryId}-${itemId}`}>
        <div className='clear_icon' onClick={() => handleClearSubcategory(categoryId, itemId)}>
          <img src='/assets/images/white/close.svg' alt='clear filter' />
        </div>
        <div className='clear_title'>{language === 'ar' ? subCategory.name_ar || "Category" : subCategory.name_en || "فئة"}</div>
      </div>
    );
  };

  return (
    <div className='col-12 col-md-2'>

      <div className='current_filter'>
        {Object.keys(filters).map(categoryId => {
          const category = categories.find(c => c.id == categoryId);
          if (!category) return null;
          const selectedItems = filters[categoryId] || [];

          return (
            <div key={`category-${categoryId}`} className='current_filter'>
              {selectedItems.map(itemId => {
                if (itemId == categoryId) {
                  return renderCategoryFilter(categoryId, category);
                }
                return renderSubcategoryFilter(categoryId, itemId, category);
              })}
            </div>
          );
        })}
      </div>
      {Object.keys(filters).length > 0 && (
        <div className='clear_all' onClick={handleClearAll}>
          <div className='clear_icon'>
            <img src='/assets/images/white/close.svg' alt='clear filter' />
          </div>
          <div>{t('clear_all')}</div>
        </div>
      )}

      {/* Main Categories Accordion */}
      {categories && (
        <Accordion multiple activeIndex={activeMainIndex} onTabChange={handleMainAccordionChange}>
          <AccordionTab
            header={
              <div className='all_cates_filter'>
                <div>
                  <img src={`/assets/images/${theme}/all_cates.svg`} alt='categories icon' />
                </div>
                <div className='filter_section_title'>{t('all_cates')}</div>
                <div>
                  <img
                    src='/assets/images/white/close_collapse.svg'
                    alt='toggle icon'
                    style={{
                      transform: activeMainIndex.includes(0) ? "rotate(180deg)" : "none",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </div>
              </div>
            }>
            <div className='categories-container'>
              {categories.map(category => {
                const checkState = getCategoryCheckState(category.id);

                return (
                  <div key={`category-${category.id}`} className='category-item'>
                    <div
                      className={`category-header filter_item ${expandedCategories[category.id] ? "active" : ""}`}
                      onClick={() => category.children?.length > 0 && toggleCategory(category.id)}>
                      <input
                        type='checkbox'
                        id={`category-checkbox-${category.id}`}
                        className='hidden-checkbox'
                        checked={checkState === "checked"}
                        ref={el => {
                          if (el) {
                            el.indeterminate = checkState === "indeterminate";
                          }
                        }}
                        onChange={e => handleCategoryFilterChange(category.id, e.target.checked, e)}
                      />
                      <label htmlFor={`category-checkbox-${category.id}`} className='custom-checkbox-label'>
                        <span
                          className={`custom-checkmark ${
                            checkState === "indeterminate" ? "indeterminate" : ""
                          }`}></span>
                      </label>
                      <div className='filter_item_title'>{language === 'ar' ? category.name_ar || "Category" : category.name_en || "فئة"}</div>

                      {category.children?.length > 0 && (
                        <div>
                          <img
                            src='/assets/images/white/close_collapse.svg'
                            alt='toggle icon'
                            style={{
                              transform: expandedCategories[category.id] ? "rotate(180deg)" : "none",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        </div>
                      )}
                    </div>

                    {expandedCategories[category.id] && category.children?.length > 0 && (
                      <div className='subcategories-list'>
                        {category.children.map(subCategory => (
                          <div key={`subcategory-${subCategory.id}`} className='subcategory-item'>
                            <input
                              type='checkbox'
                              id={`subcategory-checkbox-${subCategory.id}`}
                              className='hidden-checkbox'
                              checked={filters[category.id]?.includes(subCategory.id) || false}
                              onChange={e =>
                                handleSubcategoryFilterChange(category.id, subCategory.id, e.target.checked)
                              }
                            />
                            <label htmlFor={`subcategory-checkbox-${subCategory.id}`} className='custom-checkbox-label'>
                              <span className='custom-checkmark'></span>
                              <span className='ml-2'>{language === 'ar' ? subCategory.name_ar || "subCategory" : subCategory.name_en || "فئة"}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </AccordionTab>
        </Accordion>
      )}
    </div>
  );
}

export default FilterShop;
